query liabilitySpecial(
  $specialId: UUID!
  $specialSelectionLiabilitiesFilter: SpecialSelectionLiabilityFilter
) {
  liabilitySpecial: specialMarketBySpecialId(specialId: $specialId) {
    specialId
    specialName
    resultedAfter
    offeringStatus
    displayStatus
    resultingStatus
    selections
    sportIds
    competitions {
      nodes {
        competitionId
        competitionName
      }
    }
    events {
      nodes {
        eventId
        eventName
      }
    }
    specialSelectionLiabilities: specialSelectionLiabilitiesBySpecialId(
      filter: $specialSelectionLiabilitiesFilter
    ) {
      nodes {
        selectionId
        specialId
        operatorId
        specialName
        betsCount
        volume
        pnl
      }
    }
  }
}
